import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import EtaHint from '../components/EtaHint';
import { pushToast } from '../hooks/useToasts';
export default function Decode() {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [file, setFile] = useState(null);
    const [sampleGroup, setSampleGroup] = useState(1);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!file)
            return;
        setBusy(true);
        setError(null);
        const fd = new FormData();
        fd.append('file', file);
        fd.append('params', JSON.stringify({ sampleGroup }));
        try {
            await api.post('/jobs/decode', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            pushToast({ kind: 'info', title: t('jobLaunched.title'), msg: t('jobLaunched.msg') });
            nav('/dashboard');
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "prose", children: [_jsx("h1", { children: t('decode.title') }), _jsxs("form", { onSubmit: onSubmit, className: "card form-card", children: [_jsxs("label", { children: [t('decode.videoLabel'), _jsx("input", { type: "file", accept: "video/*", required: true, onChange: (e) => setFile(e.target.files?.[0] ?? null) })] }), _jsxs("label", { children: [t('decode.sampleGroup'), _jsx("input", { type: "number", min: 1, max: 30, value: sampleGroup, onChange: (e) => setSampleGroup(Math.max(1, Number(e.target.value) || 1)) }), _jsx("small", { className: "muted", children: t('decode.sampleGroupHelp') })] }), error && _jsx("p", { className: "error", children: error }), _jsx(EtaHint, { kind: "decode" }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy || !file, children: busy ? t('common.loading') : t('decode.submit') })] })] }));
}
